import { render, staticRenderFns } from "./BreadCrumbHeader.vue?vue&type=template&id=15526574&scoped=true&"
import script from "./BreadCrumbHeader.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbHeader.vue?vue&type=style&index=0&id=15526574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15526574",
  null
  
)

export default component.exports